enum PaymentType {
    COD = 1,
    Online = 2,
    Voucher = 3,
    ReedemPoints = 4,
    Cheque = 5
}
export default PaymentType;